import { JobDetailAppointments } from '@/components/Domains/Jobs/jobDetailAppointments'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const SearchSchema = z.object({
  selectedMonth: z.string().optional(),
})

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/appointments')({
  component: JobDetailAppointments,
  validateSearch: SearchSchema.parse,
})
